import * as React from "react"

const SvgVideo = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M4 20.143q-.824 0-1.413-.588A1.93 1.93 0 0 1 2 18.143v-12q0-.825.587-1.413A1.93 1.93 0 0 1 4 4.143h12q.824 0 1.413.587.587.588.587 1.413v4.5l3.15-3.15q.25-.25.55-.125t.3.475v8.6q0 .35-.3.475t-.55-.125L18 13.643v4.5q0 .825-.587 1.412a1.93 1.93 0 0 1-1.413.588zm0-2h12v-12H4z" />
  </svg>
)
export default SvgVideo
